<template>
  <h3
    class="text-ontick-large font-bold text-ontick-steel-900 dark:text-gray-300"
  >
    <slot></slot>
  </h3>
</template>

<script>
export default {
  name: "ontick-card-title",
};
</script>
